import {Component, Input, OnInit} from '@angular/core';
import {CourseProduct} from "../../types";

@Component({
  selector: 'app-recipe',
  templateUrl: './recipe.component.html',
  styleUrls: ['./recipe.component.scss']
})
export class RecipeComponent implements OnInit {

  @Input()
  recipe!: CourseProduct[];

  constructor() { }

  ngOnInit(): void {
  }

}
